import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '../server/layout/Stack/index';
import { Row } from '../server/layout/Row/index';
import { SearchInput } from '../SearchInput/SearchInput';
import { StickyBar } from '../StickyBar/StickyBar';
import { TabBar } from '../TabBar/TabBar';
export function FilterShelf({ search = true, searchPlaceholder = 'Search…', searchValue, onSearchChange, tabs, value, onChange, actions, tabActions, appliedFilters, sticky = false, }) {
    const content = (_jsxs(Stack, { gap: "lg", children: [search && (_jsxs(Row, { gap: "sm", align: "center", wrap: true, children: [_jsx(SearchInput, { placeholder: searchPlaceholder, value: searchValue, onChange: onSearchChange, fluid: true, 
                        // `flex: 1 1 14rem` + the parent Row's `wrap` together drop
                        // the actions to a second line at <= ~440px (e.g. 320px
                        // viewport). Without the 14rem min-flex-basis the search
                        // input shrinks to ~60px and shows only "Se" while the
                        // actions still overrun the column edge.
                        style: { flex: '1 1 14rem', minWidth: 0 } }), actions] })), appliedFilters, tabs && (_jsx(TabBar, { items: tabs, value: value, onChange: onChange, actions: tabActions }))] }));
    const wrapper = sticky
        ? _jsx(StickyBar, { children: content })
        : (_jsx("div", { style: {
                paddingBlock: 'var(--space-lg)',
                background: 'inherit',
            }, children: content }));
    return wrapper;
}
//# sourceMappingURL=FilterShelf.js.map